import {
  Autocomplete,
  Breadcrumbs,
  Button,
  Card,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextareaAutosize,
  Input,
  InputLabel,
  TextField,
  Typography,
  Box,
  Tab,
  CircularProgress,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TagsInput } from "react-tag-input-component";
import LenghtUnitList from "../../compenents/app/LenghtUnitList";
import MassUnitList from "../../compenents/app/MassUnitList";
import {
  useEditPartMutation,
  useGetPartByIdMutation,
} from "../../redux/reducer/features/Part/partSlice";
import { useGetManufacturersQuery } from "../../redux/reducer/features/Product/productSlice";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Part, PartInitialValues } from "../../models/features/Part/Parts";
import ManagePartImage from "./ManagePartImage";
import PageLoader from "../app/PageLoader";
import { PartValidationSchema } from "./../../models/features/Part/Parts";

export interface EditPartProps {}

export const EditPart: React.FunctionComponent<EditPartProps> = () => {
  const [partDetail, setPartDetail] = React.useState<Part>();
  const [detailMutation, detailMutationResult] = useGetPartByIdMutation();
  const [partMutation, partMutationResult] = useEditPartMutation();
  const manufacturers = useGetManufacturersQuery();
  let { id } = useParams();
  let navigate = useNavigate();
  const [value, setValue] = React.useState(1);
  React.useEffect(() => {
    detailMutation({ data: id });
  }, []);

  React.useEffect(() => {
    if (detailMutationResult.data) {
      setPartDetail(detailMutationResult.data.entity);
    }
  }, [detailMutationResult]);

  const manufacturerDefaultProps = {
    options:
      manufacturers.data && manufacturers.data.entityList
        ? manufacturers.data.entityList
        : [],
    getOptionLabel: (option: any) => option.title,
  };

  const handleOnSubmit = (values: Part) => {
    partMutation({ data: { id: id, part: values } });
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (partMutationResult.isSuccess && partMutationResult.data.entity) {
      navigate("/Parts");
    }
  }, [partMutationResult]);

  return (
    <>
      <Container maxWidth={false}>
        <PageLoader isLoading={detailMutationResult.isLoading}></PageLoader>
        <Card style={{ padding: "10px", margin: "10px" }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/">
              Dashboard
            </Link>
            <Link color="inherit" to="/Parts">
              Parts
            </Link>
            <Typography color="text.primary">Edit Part</Typography>
          </Breadcrumbs>
        </Card>
        <Card style={{ padding: "10px", margin: "10px" }}>
          <TabContext value={value.toString()}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Product Detail" value="1" />
                <Tab label="Images" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              {partDetail ? (
                <Formik
                  initialValues={partDetail ?? PartInitialValues}
                  enableReinitialize
                  validationSchema={PartValidationSchema}
                  onSubmit={(values) => {
                    handleOnSubmit(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                  }) => (
                    <>
                      <Form>
                        <Card style={{ padding: "10px", margin: "10px" }}>
                          <Grid container spacing={3} p={5}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="partNumber"
                                name="partNumber"
                                label="Part Number"
                                fullWidth
                                autoComplete="given-name"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.partNumber}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="productId"
                              />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="title"
                                name="title"
                                label="Title"
                                fullWidth
                                autoComplete="family-name"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.title}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="title"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                id="shortName"
                                name="shortName"
                                label="Short Name"
                                fullWidth
                                autoComplete="shipping address-line1"
                                variant="standard"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.shortName}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="shortTitle"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Autocomplete
                                {...manufacturerDefaultProps}
                                id="clear-on-escape"
                                clearOnEscape
                                defaultValue={partDetail?.manufacturer}
                                onChange={(e, value) => {
                                  setFieldValue(
                                    "manufacturerId",
                                    value ? value.id : ""
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Manufacturer"
                                    variant="standard"
                                  />
                                )}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="manufacturerId"
                              />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.depth" shrink>
                                Depth
                              </InputLabel>
                              <Input
                                id="dimension.depth"
                                name="dimension.depth"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.depth}
                                endAdornment={
                                  <LenghtUnitList
                                    value={values.dimension?.depthUnit}
                                    id={"dimension.depthUnit"}
                                    name={"dimension.depthUnit"}
                                    onChange={handleChange}
                                  ></LenghtUnitList>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.height" shrink>
                                Height
                              </InputLabel>
                              <Input
                                id="dimension.height"
                                name="dimension.height"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.height}
                                endAdornment={
                                  <LenghtUnitList
                                    value={values.dimension?.heightUnit}
                                    id={"dimension.heightUnit"}
                                    name={"dimension.heightUnit"}
                                    onChange={handleChange}
                                  ></LenghtUnitList>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.width" shrink>
                                width
                              </InputLabel>
                              <Input
                                id="dimension.width"
                                name="dimension.width"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.width}
                                endAdornment={
                                  <LenghtUnitList
                                    value={values.dimension?.widthUnit}
                                    id={"dimension.widthUnit"}
                                    name={"dimension.widthUnit"}
                                    onChange={handleChange}
                                  ></LenghtUnitList>
                                }
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <InputLabel htmlFor="dimension.weight" shrink>
                                Weight
                              </InputLabel>
                              <Input
                                id="dimension.weight"
                                name="dimension.weight"
                                fullWidth
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension?.weight}
                                endAdornment={
                                  <MassUnitList
                                    value={values.dimension?.weightUnit}
                                    id={"dimension.weightUnit"}
                                    name={"dimension.weightUnit"}
                                    onChange={handleChange}
                                  ></MassUnitList>
                                }
                              />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                              <TagsInput
                                value={values.tags}
                                onChange={(tags) => {
                                  setFieldValue("tags", tags);
                                }}
                                name="Tags"
                                placeHolder="enter tags"
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <TextareaAutosize
                                aria-label="empty textarea"
                                placeholder="Description"
                                id={"description"}
                                name={"description"}
                                minRows={5}
                                style={{ width: "100%" }}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.description}
                              />
                              <ErrorMessage
                                className="error-msg"
                                component={"div"}
                                name="description"
                              />
                            </Grid>
                            <Grid mt={-2} item xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="secondary"
                                    name="isEnabled"
                                    value="yes"
                                    checked={values.isEnabled}
                                    onChange={(e) => {
                                      console.log(e);
                                      setFieldValue(
                                        "isEnabled",
                                        e.target.checked
                                      );
                                    }}
                                  />
                                }
                                label="Enabled this product to be Use"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Button
                                variant="contained"
                                type="submit"
                                disabled={partMutationResult.isLoading}
                                onClick={() => {
                                  console.log(errors);
                                  console.log(values);
                                }}
                                startIcon={
                                  partMutationResult.isLoading ? (
                                    <CircularProgress
                                      size="1.2rem"
                                      color="inherit"
                                    />
                                  ) : (
                                    ""
                                  )
                                }
                              >
                                Update
                              </Button>
                            </Grid>
                          </Grid>
                        </Card>
                      </Form>
                    </>
                  )}
                </Formik>
              ) : (
                ""
              )}
            </TabPanel>
            <TabPanel value="2">
              <ManagePartImage
                partId={partDetail?.id ?? ""}
                images={partDetail?.images ?? []}
                partDetail={partDetail}
                setPartDetail={setPartDetail}
              ></ManagePartImage>
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </>
  );
};
